import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as c } from "./index.es2444.js";
const h = (i) => {
  const { fill: l, size: d, innerElementFill: r, outline: n } = c(i), t = i.color === "outline" || i.color === "gray";
  return /* @__PURE__ */ o(
    "svg",
    {
      width: d,
      height: d,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ o("g", { clipPath: "url(#clip0_260_3383)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
              fill: t ? n : l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M4.499 9C4.499 8.72331 4.72331 8.499 5 8.499H13C13.2767 8.499 13.501 8.72331 13.501 9C13.501 9.27669 13.2767 9.501 13 9.501H5C4.72331 9.501 4.499 9.27669 4.499 9Z",
              fill: t ? n : l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9 4.499C9.27669 4.499 9.501 4.72331 9.501 5V13C9.501 13.2767 9.27669 13.501 9 13.501C8.72331 13.501 8.499 13.2767 8.499 13V5C8.499 4.72331 8.72331 4.499 9 4.499Z",
              fill: t ? n : l
            }
          )
        ] }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_260_3383", children: /* @__PURE__ */ e(
          "rect",
          {
            shapeRendering: "optimizeQuality",
            width: "18",
            height: "18",
            fill: r
          }
        ) }) })
      ]
    }
  );
};
h.__tags = [];
export {
  h as AddCircledIcon
};
//# sourceMappingURL=index.es248.js.map
